const HIDDEN_PATH_PREFIXES = [
  '/landings/help-me-choose',
  '/water-hardness',
  '/forms/',
  '/blog',
  '/showcase',
  '/services/business',
  '/services/plc-industrial-programming',
  '/services/water-softener',
  '/about',
  '/contact',
  '/warranty',
  '/privacy-policy',
  '/terms-of-service',
]

export function shouldHideDiagnosticToolsLauncher(pathname = '') {
  return HIDDEN_PATH_PREFIXES.some((prefix) => (pathname || '').startsWith(prefix))
}
